import axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';

import { Config } from '../../common/config';
import AlertModal from '../../components/alertModal';
import LeftMenu from '../../components/leftMenu';
import Pagination from '../../components/pagination';
import translations from '../../data/translation';
 
import useStoreNo from '../../hooks/useStoreNo';

export default function QnaList() {
  const navigate = useNavigate();
  
  
  const language = useSelector(state => state.language.language);
  const t = translations[language];
  const [filterFrom] = useState(dayjs());
  const [filterTo] = useState(dayjs());
  const [searchCondition] = useState({
    searchSection: '',
    searchTake: Config.PAGE_SIZE_LIST[0],
    searchFrom: dayjs(filterFrom).format('YYYY-MM-DD'),
    searchTo: dayjs(filterTo).format('YYYY-MM-DD'),
  });
  const [data, setData] = useState([]);
  const [, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInfo] = useState({
    isCancel: false,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const storeNo = useStoreNo();

  const goQna = qnaNo => {
    ('goQna');
    const passData = {
      qnaNo: qnaNo,
    };
    navigate(`/${storeNo}/qna-content`, { state: passData });
  };

  // JWT refresh is handled elsewhere

  const getData = useCallback(async () => {
    try {
      const ret = await axios.get(
        Config.API_SERVER +
          'qna' +
          '?pageNo=' +
          currentPage +
          '&pageSize=' +
          searchCondition.searchTake,
        {
          withCredentials: true,
        }
      );

      if (ret?.data?.data) {
        const count = ret.data.data.totalCount;

        const tp = Math.ceil(count / searchCondition.searchTake);

        setTotalPage(tp);
        setTotal(count);

        setData(ret.data.data.list);
      }
    } catch (error) {
      console.error('Error getData:', error);
    }
  }, [currentPage, searchCondition.searchTake]);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchCondition.searchTake]);

  const pageChange = page => {
    setCurrentPage(page);
  };

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={() => setModalOpen(false)}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>

      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>
            <NavLink to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}>
              {t.home}
            </NavLink>
          </li>
          <li>{t.serviceInquiry}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="qna" />

          <section className="rightcontant_box">
            <h2 className="tit_01">{t.serviceInquiry}</h2>

            <article className="search_card">
              <div className="search_row">
                <div className="search_field">
                  <span className="field_label">{t.searchCondition}</span>
                  <select className="search_input_02">
                    <option value="">{t.select}</option>
                    <option value="title">{t.title}</option>
                    <option value="titleContent">
                      {t.title} + {t.content}
                    </option>
                    <option value="author">{t.author}</option>
                  </select>
                </div>
                <div className="search_field">
                  <span className="field_label">{t.searchKeyword}</span>
                  <input type="text" name="" placeholder={t.searchKeyword} />
                </div>
                <div className="search_btns">
                  <button
                    type="button"
                    className="button_05 button_black"
                    onClick={getData}
                  >
                    {t.search}
                  </button>
                </div>
              </div>
            </article>

            <table className="table_box_01 table_box_02">
              <colgroup>
                <col width="60px" />
                <col width="180px" />
                <col width="610px" />
                <col width="150px" />
                <col width="150px" />
              </colgroup>

              <thead>
                <tr>
                  <th>{t.no}</th>
                  <th>{t.questionType}</th>
                  <th>{t.title}</th>
                  <th>{t.author}</th>
                  <th>{t.registrationDate}</th>
                </tr>
              </thead>

              <tbody>
                {data &&
                  data.length > 0 &&
                  data.map((item, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          {t.qnaCategoryDesc[item.qnaCategoryeDesc] ||
                            item.qnaCategoryeDesc}
                        </td>
                        <td>
                          <div className="table_03">
                            <div
                              className={
                                item.noticeYn === 'Y'
                                  ? 'table_icon button_yellow'
                                  : 'table_icon button_black'
                              }
                            >
                              {item.noticeYn === 'Y' ? t.public : t.private}
                            </div>
                            <div className="table_03_002">
                              <span
                                style={{ cursor: 'pointer' }}
                                onClick={() => goQna(item.qnaNo)}
                              >
                                {item.title}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>{item.userId}</td>
                        <td>
                          {(() => {
                            const isoDate = item.updDttm;
                            const date = new Date(isoDate);
                            const year = date.getFullYear();
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              '0'
                            );
                            const day = String(date.getDate()).padStart(2, '0');
                            return `${year}-${month}-${day}`;
                          })()}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="table_03 table_03_001">
                            <div className="table_icon button_gray_line_bg">
                              {t.answer}
                            </div>
                            <div className="table_03_002">{item.aContent}</div>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
            <ul className="page_box">
              <Pagination totalPage={totalPage} onPageChange={pageChange} />
            </ul>

            <article className="button_box_03">
              <NavLink to={`/${storeNo}/qna-manage`}>
                <button
                  type="button"
                  className="button_01 button_03 button_red"
                >
                  {t.askQuestion}
                </button>
              </NavLink>
            </article>
          </section>
        </section>
      </main>
    </>
  );
}
